module.exports = __webpack_public_path__ + "static/media/mode-32.b2769f1f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-32.svg
// module id = 1005
// module chunks = 2